/**
 * THE PINNED RAIL — a fixed 0..1 scale on the price grid, drawn nowhere.
 *
 * <h2>What it is for</h2>
 *
 * The price axis rescales with the zoom, so anything placed "at the bottom" as a PRICE drifts the
 * moment a reader zooms — the mark was at the foot of the grid when it was computed and is
 * halfway up it a gesture later. A fraction of the grid cannot drift, because the grid is what it
 * is measured against.
 *
 * <p>Two things ride it today: the aspect rail, and the CTS timing marks, which moved here on
 * 2026-10-21 because a timing point says WHEN a turn is due and nothing about the level.
 *
 * <h2>⚠ A LEAF MODULE, and that is the whole reason this file exists</h2>
 *
 * These two constants lived in `chartDataProcessor`, which imports `ctsPillars` — so the moment
 * `ctsPillars` needed the rail position, the two imported each other. An ES-module cycle does not
 * fail loudly: the binding is hoisted, so a constant read inside a function body happens to
 * resolve while one read at module-evaluation time silently comes back `undefined`. Nothing in
 * lint or the build catches it and the symptom is a mark at NaN, which draws nothing.
 *
 * <p>So they live in a module that imports nothing. `chartDataProcessor` re-exports them, because
 * they were part of its surface before this and tests import them from there.
 *
 * <p>Index 13 is the entry in `EChartComponent`'s yAxis array. It is APPENDED, never inserted:
 * every series names its axis by index, so adding one anywhere else renumbers the lot and the
 * symptom is RSI drawn on the volume scale rather than an error.
 */

/** The yAxis index of the rail. See EChartComponent's yAxis array. */
export const RAIL_Y_AXIS_INDEX = 13;

/**
 * Three percent up from the floor.
 *
 * <p>Enough to clear the axis line without floating. A mark ON the floor is clipped by the axis
 * and reads as half a triangle.
 */
export const RAIL_Y_POSITION = 0.03;
